// @ts-check

import {
  GET_PUBLISHERS,
  GET_PUBLISHER,
  GET_PUBLISHERS_STATS,
  CREATE_PUBLISHER,
  UPDATE_PUBLISHER,
  GET_PUBLISHER_REFERENCES,
  DELETE_PUBLISHER,
  GET_ACCOUNT_SETTINGS
} from './actionTypes';
import { STATUS_PENDING, getActionStatusName } from '@/store/helpers';

export const isFetchingPublishers = (_, getters) => {
  return (
    getters.getPublishersStatus.status === STATUS_PENDING ||
    getters.getPublisherStatus.status === STATUS_PENDING
  );
};
export const isPublisherReferencesLoading = (_, getters) => {
  return getters.getPublisherReferencesStatus.status === STATUS_PENDING;
};
export const isPublisherDeleteLoading = (_, getters) => {
  return getters.deletePublisherStatus.status === STATUS_PENDING;
};

export const getAccountSettingsStatus  = (state) =>
  state.status[getActionStatusName(GET_ACCOUNT_SETTINGS)] || {};
export const getPublisherStatus = (state) =>
  state.status[getActionStatusName(GET_PUBLISHER)] || {};
export const getPublishersStatus = (state) =>
  state.status[getActionStatusName(GET_PUBLISHERS)] || {};
export const getPublishersStatsStatus = (state) =>
  state.status[getActionStatusName(GET_PUBLISHERS_STATS)] || {};
export const createPublisherStatus = (state) =>
  state.status[getActionStatusName(CREATE_PUBLISHER)] || {};
export const updatePublisherStatus = (state) =>
  state.status[getActionStatusName(UPDATE_PUBLISHER)] || {};
export const getPublisherReferencesStatus = (state) =>
  state.status[getActionStatusName(GET_PUBLISHER_REFERENCES)] || {};
export const deletePublisherStatus = (state) =>
  state.status[getActionStatusName(DELETE_PUBLISHER)] || {};
export const getDisplayPublishers = (state, getters) => {
  if (getters.isFetchingPublishers) {
    return [];
  }
  return state.publishers;
};
